<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <TsMenuButton ref='tsMenuButton' @methodEnum='methodEnum' ></TsMenuButton>
      <div class="h100-140 h-scroll" style="padding-top: 30px;">
        <OnlineUserChart ref='onlineUserChart'></OnlineUserChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TsMenuButton from '../../components/tsConfig/TsMenuButton';
import OnlineUserChart from '../../components/tsConfig/OnlineUserStatistics/OnlineUserChart';

export default {
  name: 'OnlineUserStatisticsPage',
  components: {
    BasicLayout,
    TsMenuButton,
    OnlineUserChart
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.onlineUsereStatistics')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.onlineUserChart.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
